module.exports = __webpack_public_path__ + "img/banner_mb.ffbf4e5.webp";